module.exports = __webpack_public_path__ + "static/media/LIBERTY_Logo.7efbe127.svg";